import { Injectable } from "@angular/core";
import { ApiService } from "@youm-front/api/data-access";
import { RoomPastInMs } from "@youm-front/room/domain";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {
  RoomCreateRequestDTO,
  RoomCreateResponseDTO,
  RoomCreateResponseDTORaw,
  RoomDeleteRequestDTO,
  RoomsListRequestDTO,
  RoomsListResponseDTO,
  RoomsListResponseRaw,
  RoomUpdateRequestDTO,
  RoomUpdateResponseDTO
} from "../dto";
import { RoomUpdateResponseDTORaw } from "../dto/RoomUpdateResponseDTO";

@Injectable()
export class RoomsListService {
  constructor(private readonly apiService: ApiService) {}

  roomCreate(
    roomCreateRequestDTO: RoomCreateRequestDTO
  ): Observable<RoomCreateResponseDTO> {
    const { title, description, startAt } = roomCreateRequestDTO.data;

    return this.apiService
      .post<RoomCreateResponseDTORaw>("rooms", {
        title,
        description,
        startAt
      })
      .pipe(map((_) => new RoomCreateResponseDTO({ room: _.room })));
  }

  roomDelete(roomDeleteRequestDTO: RoomDeleteRequestDTO): Observable<void> {
    const { roomId } = roomDeleteRequestDTO.data;

    return this.apiService.delete<void>(`rooms/${roomId}`);
  }

  roomUpdate(
    roomUpdateRequestDTO: RoomUpdateRequestDTO
  ): Observable<RoomUpdateResponseDTO> {
    const { roomId, roomTitle, roomDescription, roomStartAt } =
      roomUpdateRequestDTO.data;

    return this.apiService
      .put<RoomUpdateResponseDTORaw>(`rooms/${roomId}`, {
        roomTitle,
        roomDescription,
        roomStartAt
      })
      .pipe(map((_) => new RoomUpdateResponseDTO(_)));
  }

  roomsList(
    _roomsListRequestDTO: RoomsListRequestDTO
  ): Observable<RoomsListResponseDTO> {
    const params = new URLSearchParams();
    const roomStartAtLowerBoundMs = Date.now() - RoomPastInMs;

    params.set("roomStartAtLowerBound", roomStartAtLowerBoundMs + "");

    return this.apiService
      .get<RoomsListResponseRaw>(`rooms?${params}`)
      .pipe(map((_) => new RoomsListResponseDTO({ rooms: _.rooms })));
  }
}
